module.exports = __webpack_public_path__ + "img/wales.636a3b6f.svg";